import { render } from "./GavContractsForm.vue?vue&type=template&id=342d87e7&ts=true"
import script from "./GavContractsForm.vue?vue&type=script&lang=ts"
export * from "./GavContractsForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__